const rankingItems = [
  {
    rank: 1,
    title: '《逆流而上》',
    subtitle: '都市职场 · 豆瓣 8.7',
    hot: '986万',
    trend: 'up',
  },
  {
    rank: 2,
    title: '《星际迷途：新纪元》',
    subtitle: '科幻动作 · 票房冠军',
    hot: '872万',
    trend: 'up',
  },
  {
    rank: 3,
    title: '《长安十二时辰》续集',
    subtitle: '古装悬疑 · 口碑黑马',
    hot: '765万',
    trend: 'up',
  },
  {
    rank: 4,
    title: '《深海奇缘》',
    subtitle: '动画奇幻 · 国漫之光',
    hot: '698万',
    trend: 'down',
  },
  {
    rank: 5,
    title: '《迷雾追踪》第三季',
    subtitle: '悬疑犯罪 · 高分续订',
    hot: '621万',
    trend: 'new',
  },
];

export default function RankingSection() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return { icon: 'ri-arrow-up-line', color: 'text-red-500' };
    if (trend === 'down') return { icon: 'ri-arrow-down-line', color: 'text-foreground-400' };
    return { icon: 'ri-sparkling-line', color: 'text-accent-500' };
  };

  const rankColor = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-white';
    if (rank === 2) return 'bg-accent-500 text-white';
    if (rank === 3) return 'bg-secondary-500 text-white';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热度榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            实时更新的影视热度排名，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-[700px] mx-auto space-y-3">
          {rankingItems.map((item) => {
            const ti = trendIcon(item.trend);
            return (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-200/50 transition-all cursor-pointer"
              >
                <div
                  className={`w-9 h-9 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${rankColor(item.rank)}`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.subtitle}</p>
                </div>
                <div className="flex items-center gap-1.5 flex-shrink-0">
                  <span className="text-xs font-medium text-accent-600 whitespace-nowrap">
                    {item.hot}热度
                  </span>
                  <span className={`w-4 h-4 flex items-center justify-center ${ti.color}`}>
                    <i className={`${ti.icon} text-xs w-3 h-3 flex items-center justify-center`}></i>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}